import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-games-page',
  templateUrl: './games-page.component.html',
  styleUrls: ['./games-page.component.scss'],
})
export class GamesPageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
